// /frontend/src/api/events.js
// Event-API-Service: nutzt zentrale Axios-Instanz mit Interceptors

import api from '@/services/api';

export const eventsApi = {
  /**
   * Lädt Events für ein Datum und Lehrkraft.
   * teacherId: Zahl oder 'me'
   * date: 'YYYY-MM-DD'
   * groupBy (optional): 'teacher' | 'student'
   */
  getToday(params = { date: null, teacherId: 'me', groupBy: null }) {
    const query = new URLSearchParams();
    if (params.date) query.set('date', params.date);
    if (params.teacherId) query.set('teacherId', params.teacherId);
    if (params.groupBy) query.set('groupBy', params.groupBy);
    return api.get(`/events?${query.toString()}`);
  },

  /**
   * Lädt gruppierte Tagesübersicht nach Lehrer oder Schüler.
   * params: { date: 'YYYY-MM-DD', groupBy: 'teacher'|'student', teacherId?: number|'me'|'all' }
   */
  getDayGrouped(params = { date: null, groupBy: 'teacher', teacherId: 'me' }) {
    const query = new URLSearchParams();
    if (params.date) query.set('date', params.date);
    if (params.groupBy) query.set('groupBy', params.groupBy);
    if (params.teacherId) query.set('teacherId', params.teacherId);
    return api.get(`/events/day-grouped?${query.toString()}`);
  },


  /**
   * Markiert ein Event als Ausfall/geschlossen.
   * payload: { reason: string, createReplacement?: boolean, replacement?: { startsAt, endsAt, topic?, location?, capacity?, teacherId? }, moveParticipants?: boolean }
   */
  cancelEvent(eventId, payload) {
    return api.post(`/events/${encodeURIComponent(eventId)}/cancel`, payload);
  },

  /**
   * Legt ein Event zu einer Offer-Template-ID an.
   * payload: { teacherId, topic, startsAt, endsAt, location?, capacity? }
   */
  createForOffer(offerTemplateId, payload) {
    return api.post(`/offers/${encodeURIComponent(offerTemplateId)}/events`, payload);
  },

  /**
   * Aktualisiert Event-Felder (aktuell: topic)
   */
  updateEvent(eventId, payload) {
    return api.patch(`/events/${encodeURIComponent(eventId)}`, payload);
  },

  /**
   * Setzt Status = 'ongoing'
   */
  startEvent(eventId) {
    return api.post(`/events/${encodeURIComponent(eventId)}/start`);
  },

  /**
   * Check-in für alle Teilnehmenden (inkl. Gruppenentfaltung)
   */
  checkInAll(eventId) {
    return api.post(`/events/${encodeURIComponent(eventId)}/checkin-all`);
  },

  /**
   * Check-out für alle mit vorhandenem Attendance-Eintrag
   */
  checkOutAll(eventId) {
    return api.post(`/events/${encodeURIComponent(eventId)}/checkout-all`);
  },

  deleteEvent(eventId) {
    return api.delete(`/events/${encodeURIComponent(eventId)}`);
  }
};
